import * as Sentry from '@sentry/react';

export const sendReportToSentry = (error, { origin }) => {
  Sentry.withScope((scope) => {
    scope.setTags({
      caught: 'true',
      origin,
    });
    Sentry.setExtra('error', error);
    Sentry.captureException(error);
  });
};
